<template>
  <div>
    <div
      class="bulk-action fixed bottom-2 left-0 lg:left-28 flex justify-center w-full"
      v-if="showBulkAction"
    >
      <div class="bulk-action__wrapper flex bg-indigo-80 rounded-lg pl-3 pr-1 py-2 text-white-100">
        <div class="flex gap-1 items-center mr-2">
          {{ selectedPresentations.length }} {{ $i18nPresenter.t("selected") }}
        </div>
        <aha-antd-button
          variant="tertiary"
          class="flex gap-1 items-center cursor-pointer bg-indigo-80"
          @click="handleAllPresentationSelectV2(true)"
          v-if="!isAllPresentationsSelectedV2"
          :iconName="'aha-click'"
          :iconViewBox="'0 0 16 16'"
          :iconClasses="'stroke-color'"
        >
          {{ $i18nPresenter.t("Select all") }}
        </aha-antd-button>
        <div class="w-px h-full bg-gray-80"></div>
        <aha-antd-button
          variant="tertiary"
          class="flex gap-1 items-center cursor-pointer"
          @click="handleMoveToItemClick"
          :iconName="'aha-move'"
          :iconViewBox="'0 0 16 16'"
          :iconClasses="'stroke-color'"
          name="'MoveBulkPresentation'"
          v-aha-emit-action
        >
          {{ $i18nPresenter.t("Move to") }}
        </aha-antd-button>
        <aha-antd-button
          variant="tertiary"
          class="flex gap-1 items-center cursor-pointer move-to-trash"
          @click="handleDeletePresnItemClick"
          :iconName="'aha-trash'"
          :iconViewBox="'0 0 16 16'"
          :iconClasses="'stroke-color text-pink-80'"
          v-if="isShowMoveToTrashButton"
          name="'MoveBulkToTrash'"
          v-aha-emit-action
        >
          {{ $i18nPresenter.t("Move to trash") }}
        </aha-antd-button>
        <aha-icon-button
          @click="handleAllPresentationSelectV2(false)"
          v-aha-emit-action
        >
          <aha-icon name="aha-close" class="stroke-color" />
        </aha-icon-button>
      </div>
    </div>

    <ModalMovePresentationsV2
      :title="modalTitle"
      :selected-presentations="selectedPresentations"
      v-if="isShowingMovePresnModalV2"
      @hide="handleHideMovePresentation()"
      :destinatedFolderId="destinatedFolderId"
      :funcMovePresn="handleMovePresn"
      @updateDestinatedFolderId="updateDestinatedFolderId"
      :loadingFolderTree="loadingFolderTree"
    />
    <ModalDeletePresentations
      :deleted-presentations="selectedPresentations"
      v-if="showingDelelePresentationsModal"
      @hide="handleHideDeletePresentations()"
    />

    <ModalWarning
      v-if="showingModalWarning"
      :title="$i18nPresenter.t('Change who has access?')"
      @hide="handleHideModalWarning()"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moveFolderMixin from '@/mixins/folder/move-folderMixin'
import ModalMovePresentationsV2 from '@/components-v2/modals/MovePresentationV2.vue'
import ModalDeletePresentations from '@/components-v2/modals/DeletePresentations.vue'
import ModalWarning from '@/components-v2/common/move-presentation/ModalWarning.vue'

export default {
  name: 'BulkAction',
  components: {
    ModalMovePresentationsV2,
    ModalDeletePresentations,
    ModalWarning,
  },
  mixins: [moveFolderMixin],
  computed: {
    ...mapState({
      selectedPresentations: (state) => state.presentations.filter((presentation) => presentation.selected),
      presentationsCanMove: (state) => state.presentations.filter((presentation) => presentation.canMoveSomewhere),
    }),
    ...mapGetters('featureToggles', ['canUseMovePresentations']),
    isShowMoveToTrashButton() {
      return this.$route.name !== 'SharedWithMe' && this.$route.name !== 'ShareFolderDetail'
    },
    isAllPresentationsSelectedV2() {
      return this.selectedPresentations.length === this.presentationsCanMove.length
    },
    showBulkAction() {
      return this.canUseMovePresentations && this.selectedPresentations.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.bulk-action__wrapper {
  min-width: 235px;

  &::v-deep {
    .aha-antd-button {
      @apply text-white-100;
      border: 3px solid transparent;

      &.ant-btn-tertiary {
        &:not(.disabled):hover {
          @apply bg-indigo-80 text-purple-25;
          border-color: transparent;
        }
        &:not(.disabled):focus-visible {
          @apply text-white-100;
          @apply border-purple-30;
          box-shadow: 0 0 0 4px #D3B4FF4D;
        }
      }
      &.move-to-trash {
        @apply text-pink-80;
        &.ant-btn-tertiary {
          &:not(.disabled):hover {
            @apply bg-indigo-80 text-pink-60;
          }
          &:not(.disabled):focus-visible {
            @apply text-pink-100;
            @apply border-pink-100;
            box-shadow: 0 0 0 4px #FFBACA4D;
          }
        }
        > svg {
          transition: all 0.2s ease-in-out;
        }
        &:hover {
          > svg {
            @apply text-pink-60;
          }
        }
        &:focus-visible {
          > svg {
            @apply text-pink-100;
          }
        }
      }
    }
  }
}
</style>
